import { render, staticRenderFns } from "./SignUpNew.vue?vue&type=template&id=6ec8db58&scoped=true"
import script from "./SignUpNew.vue?vue&type=script&lang=js"
export * from "./SignUpNew.vue?vue&type=script&lang=js"
import style0 from "./SignUpNew.vue?vue&type=style&index=0&id=6ec8db58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec8db58",
  null
  
)

export default component.exports